<template>
    <!--弹窗-->
    <el-dialog
        width="650px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form
            ref="formData"
            :model="formData"
            :rules="rules"
            label-width="230px"
        >
            <el-form-item label="目标ACoS：" prop="target_acos">
                <el-input
                    v-model="formData.target_acos"
                    style="width: 300px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入目标ACoS"
                >
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
            <el-form-item label="产品价格：" prop="product_price">
                <el-input
                    v-model="formData.product_price"
                    style="width: 300px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入产品价格"
                >
                    <template slot="prepend">$</template>
                </el-input>
            </el-form-item>
            <el-form-item label="点击数：" prop="clicks">
                <el-input-number
                    v-model="formData.clicks"
                    :min="1"
                    style="width: 300px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入点击数"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="高acos幅度：" prop="tower_acos">
                <el-input
                    v-model="formData.tower_acos"
                    style="width: 300px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入高acos幅度"
                ></el-input>
            </el-form-item>
            <el-form-item label="高点击无出单：" prop="high_click_not_order">
                <el-input
                    v-model="formData.high_click_not_order"
                    style="width: 300px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入高点击无出单"
                ></el-input>
            </el-form-item>
            <el-form-item label="低点击无出单：" prop="low_click_not_order">
                <el-input
                    v-model="formData.low_click_not_order"
                    style="width: 300px;margin-right:20px;"
                    size="mini"
                    placeholder="请输入低点击无出单"
                ></el-input>
            </el-form-item>
            <div class="media-txt">从竞价优化中剔除活动</div>
            <Choice @on-exclude="onArrExclude_activity" />
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm()"
                :loading="loading"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import Choice from "./choice";
import * as api from "@/api/statistics/statistics";
export default {
    components: { Choice },
    data() {
        return {
            loading: false,
            textarea: "",
            rules: {
                target_acos: [
                    {
                        required: true,
                        message: "请输入目标ACoS",
                        trigger: "blur"
                    }
                ],
                product_price: [
                    {
                        required: true,
                        message: "请输入产品价格",
                        trigger: "blur"
                    }
                ],
                clicks: [
                    {
                        required: true,
                        message: "请输入点击数",
                        trigger: "blur"
                    }
                ],
                tower_acos: [
                    {
                        required: true,
                        message: "请输入高acos幅度",
                        trigger: "blur"
                    }
                ],
                high_click_not_order: [
                    {
                        required: true,
                        message: "请输入高点击无出单",
                        trigger: "blur"
                    }
                ],
                low_click_not_order: [
                    {
                        required: true,
                        message: "请输入低点击无出单",
                        trigger: "blur"
                    }
                ]
            },
            arrExclude_activity: [],
            formData: {
                clicks: 20,
                tower_acos: 0.9,
                high_click_not_order: 0.8,
                low_click_not_order: 0.95
            }
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        ad_id: {
            type: Number,
            default: 0
        }
    },
    methods: {
        typeNumber(str) {
            return Number(Number(str));
            // return Number(Number(str).toFixed(2));
        },
        // 保存信息
        submitForm() {
            this.$refs["formData"].validate(valid => {
                if (valid) {
                    let formData = this.formData;
                    let obj = {
                        ad_id: this.ad_id,
                        clicks: formData.clicks,
                        // asin: this.$route.query.asin,
                        target_acos: this.typeNumber(formData.target_acos),
                        product_price: this.typeNumber(formData.product_price),
                        tower_acos: this.typeNumber(formData.tower_acos),
                        high_click_not_order: this.typeNumber(
                            formData.high_click_not_order
                        ),
                        low_click_not_order: this.typeNumber(
                            formData.low_click_not_order
                        ),
                        exclude_activity: this.arrExclude_activity.join(",")
                    };
                    this.loading = true;
                    // return
                    api.reduce_bid_add(obj)
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.$message({
                                    message: "添加成功",
                                    type: "success"
                                });
                                this.$emit("refresh");
                                this.handleClose(false);
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.$message({
                                type: "error",
                                message: "网络出现问题，请刷新页面！"
                            });
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        onArrExclude_activity(arr) {
            this.arrExclude_activity = arr;
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.formData = {
                clicks: 20,
                tower_acos: 0.9,
                high_click_not_order: 0.8,
                low_click_not_order: 0.95
            };
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;
    .shu {
        border-right: 1px solid #cecfd1;
    }
    .content-div {
        width: 50%;
        padding: 25px 20px;
    }
    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }
    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }
    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;
        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }
    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
